module.exports = __webpack_public_path__ + "images/services/trello.e1b7406bd79656fdd26c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/services/trello.png
// module id = SudR
// module chunks = 2